import { FC } from 'react';

// Externals
import clsx from 'clsx';
import { NavLink as RouterLink } from 'react-router-dom';

// Material
import { Button, ListItem, makeStyles } from '@material-ui/core';

// Styles
const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    letterSpacing: 0,
    padding: '10px 8px',
    textTransform: 'none',
    width: '100%'
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  title: {
    marginRight: 'auto'
  },
  active: {
    color: theme.palette.primary.main,
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      color: theme.palette.primary.main
    }
  }
}));

interface Props {
  className?: string;
  href: string;
  icon: any;
  title: string;
}

const Item: FC<Props> = ({ className, href, icon: Icon, title }) => {
  const classes = useStyles();

  return (
    <ListItem className={clsx(classes.item, className)} disableGutters>
      <Button activeClassName={classes.active} className={classes.button} component={RouterLink} to={href}>
        {Icon && <Icon className={classes.icon} size="20" />}
        <span className={classes.title}>{title}</span>
      </Button>
    </ListItem>
  );
};

export default Item;
